import { writable } from 'svelte/store';

export const main_menu_editor_open_store = writable(false);
